import { Injectable } from "@angular/core";
import {
  Router,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from "@angular/router";
import { AuthService } from "@services/auth.service";
import { environment } from "@environments/environment";
@Injectable()
export class AuthGuardService {
  constructor(private router: Router, private authService: AuthService) {}

  public enablePublishing = environment.disableUI.enablePublishing || false;
  public enableCMS = environment.disableUI.enableCMS || false;
  public enablePreview = environment.disableUI.enablePreview || false;

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const currentRoute = state.url.substring(1);
    let path = route.data.path;
    switch (path) {
      case "settings":
        this.authService.fetchUserLight().subscribe((data: any) => {
          const userGroupId = data.data.userGroupId;
          if (userGroupId == "0") {
            return true;
          } else {
            this.router.navigate(["/accessdenied"]);
            return false;
          }
        });

        break;

      case "publishing":
        if (!this.enablePublishing) {
          this.router.navigate(["/404"]);
        }

        this.authService.fetchUserLight().subscribe((data: any) => {
          const userGroupId = data.data.userGroupId;
          if (userGroupId == "0") {
            return true;
          } else {
            this.router.navigate(["/accessdenied"]);
            return false;
          }
        });

        break;

      case "cms":
        if (!this.enableCMS) {
          this.router.navigate(["/404"]);
        }

        this.authService.fetchUserLight().subscribe((data: any) => {
          const userGroupId = data.data.userGroupId;
          if (userGroupId == "0") {
            return true;
          } else {
            this.router.navigate(["/accessdenied"]);
            return false;
          }
        });

        break;
      case "preview":
        if (!this.enablePreview) {
          this.router.navigate(["/404"]);
        }

        break;
    }
    return true;
  }
}
